import React, { useRef, useState } from 'react';
import { Loader, Dimmer, TableBody, TableCell, TableRow } from 'semantic-ui-react';
import Modal from 'react-bootstrap/Modal';
import axios from 'axios';
import { Mensaje, MensajeSiNo } from '../mensajes';
import moment from 'moment';
import CatalogoListRecibosdPagos from '../../catalogos/catalogoRecibosdePagos';
import CatalogoAlmacen from '../../catalogos/catalogoAlmacen';
import CatalogoProductosExistencias from '../../catalogos/catalogoProductosExistencias';
import CatalogoCliente from '../../catalogos/catalogoCliente';

export const ModalOperacionesInventario = (props) => {

  var op = require('../../../public/modulos/datos');
  let token = sessionStorage.getItem('jwtToken');
  const fechasistema = JSON.parse(sessionStorage.getItem('fechasistema'));
  const afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));


  const btnCancela = useRef();
  const btnAcepta = useRef();
  const btnSalir = useRef();
  const txtCodigo = useRef();
  const txtDesde = useRef();
  const txtHasta = useRef();
  const txtNumAlmacen = useRef();
  const txtNombreAlmacen = useRef();
  const txtChkTodos = useRef();
  const txtNombre = useRef();
  const txtChekTodos = useRef();
  const txtChekIngreso = useRef();
  const txtChekSalida = useRef();
  const txtChekTraslado = useRef();
  const txtTipoproducto = useRef();
  const txtMarca = useRef();
  const txtCbmrif = useRef();
  const txtRifrespon = useRef();
  const txtNomrespon = useRef();
  const txtTodosCliente = useRef();
  const txtPorCliente = useRef();
  const txtChekPrestamo = useRef();
  const txtChekDonacion = useRef();
  const txtChekResguardo = useRef();
  const txtChekAjuste = useRef();
  const txtChekCompra = useRef();
  const txtChekVence = useRef();

  const [validatipo, setValidatipo] = useState(0);
  const [combocliente, setCombocliente] = useState(0);
  const [clientvende, setClientvende] = useState('');
  const [idtproduct, setIdtproduct] = useState('');
  const [idmarca, setIdmarca] = useState('');
  const [tipoproducto, setTipoproducto] = useState([]);
  const [marca, setMarca] = useState([]);
  const [tiporif, setTipofic] = useState(null);
  const [mostrar1, setMostrar1] = useState(null);
  const [mostrar2, setMostrar2] = useState(null);
  const [mostrar3, setMostrar3] = useState(null);
  const [habimarcatipopro, setHabimarcatipopro] = useState(true);
  const [parafecha, setParafecha] = useState('');
  const [desde, setDesde] = useState('');
  const [hasta, setHasta] = useState('');
  const [disponiblec, setDisponiblec] = useState('');
  const [numnota, setNumNota] = useState('');
  const [idclient, setIdclient] = useState('');
  const [vinput, setVinput] = useState(true);
  const [validainput, setValidainput] = useState(false);
  const [activate, setActivate] = useState(false);
  const [idproduct, setIdproduct] = useState(null);
  const [idalmacen, setIdalmacen] = useState(null);
  const [valida, setValida] = useState(0);
  const [filter, setFilter] = useState(0);
  const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [tipoope, setTipoope] = useState('');
  const [botones, setBotones] = useState({
    incluir: false,
    consultar: false,
    modificar: false,
    eliminar: false,
    aceptar: true,
    cancelar: true,
    catalogo: true,
    salir: false
  });

  const [tip, setTip] = useState({
    ingreso: '',
    salida: '',
    traslado: '',
    donacion: '',
    prestamo: '',
    ajuste: '',
    resguardo: '',
    compra: '',
    vencimiento: ''
  });


  const blanquear = () => {
    setActivate(false);
    setParafecha('');
    setDisponiblec('');
    setNumNota('');
    setValidatipo(0);
    setValida(0);
    setIdclient('');
    setIdproduct(null);
    setVinput(true);
    setMostrar1(false);
    setMostrar2(false);
    setIdalmacen("");
    setDesde('');
    setHasta('');
    setFilter(0);
    setValidainput(false);
    setTipoope('');
    setTip({
      ingreso: '',
      salida: '',
      traslado: '',
      donacion: '',
      prestamo: '',
      ajuste: '',
      resguardo: '',
      compra: '',
      vencimiento: ''
    });
  }

  const cancelar = () => {
    blanquear();
    props.onHideCancelar();

  };

  const onChangeValidar = (e) => {
    e.preventDefault();

    let sigue = true;
    if (props.ope === 1) {

      if (validainput !== true) {
        if (txtNombre.current.value === '' || txtCodigo.current.value === "" || valida === 1 && txtNumAlmacen.current.value === '') {
          if (valida === 1) {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Introduzca el Código del Almacen !', icono: 'informacion' });
            txtNumAlmacen.current.focus()
          } else {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Introduzca el Código del Producto a Consultar !', icono: 'informacion' });
            txtCodigo.current.focus()
          }
          sigue = false
        } else {

          imprimirOperacionInventario();

        }
      } else {

        if (valida === 1 && txtNumAlmacen.current.value === '') {
          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Introduzca el Código del Almacen !', icono: 'informacion' });
          txtNumAlmacen.current.focus();
        } else {
          imprimirOperacionInventario();
        }

      }

    }

  }

  const onChange = (e) => {

    if (e.target.name === 'desde') {
      if (e.target.value > moment(fechasistema).format('YYYY-MM-DD')) {
        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ La Fecha seleccionada no puede ser Mayor a la Fecha Actual !', icono: 'informacion' });
        txtDesde.current.value = moment(fechasistema).format('YYYY-MM-DD');
        txtDesde.current.focus()
      } else {
        setDesde(e.target.value);
      }
    } else if (e.target.name === 'hasta') {
      setHasta(e.target.value);
    }

    if (e.target.name === 'inlineRadioOptions') {

      if (e.target.value === '1') {
        setValida(0);
        setIdalmacen('');
      } else {
        setValida(1);
      }

    }

    if (e.target.name === 'chektodos') {
      if (e.target.checked) {
        setValidainput(true);
        setVinput(false);
        setValidatipo(0);
        txtCodigo.current.value = "";
        txtNombre.current.value = "";
        setIdproduct(null);
        setTipoope('');
        setFilter(0);
        setTip({
          ingreso: '',
          salida: '',
          traslado: '',
          donacion: '',
          prestamo: '',
          ajuste: '',
          resguardo: '',
          compra: '',
          vencimiento: ''
        });
        txtChekTodos.current.checked = true;
        txtChekIngreso.current.checked = false;
        txtChekSalida.current.checked = false;
        txtChekTraslado.current.checked = false;
        txtChekAjuste.current.checked = false;
        txtChekDonacion.current.checked = false;
        txtChekPrestamo.current.checked = false;
        txtChekResguardo.current.checked = false;
        txtChekCompra.current.checked = false;
        txtChekVence.current.checked = false;
      } else {
        setValidainput(false);
        setVinput(true);
        setTipoope('');
        setFilter(1);
        setValidatipo(0);
        setTip({
          ingreso: '',
          salida: '',
          traslado: '',
          donacion: '',
          prestamo: '',
          ajuste: '',
          resguardo: '',
          compra: '',
          vencimiento: ''
        });
        txtChekTodos.current.checked = true;
        txtChekIngreso.current.checked = false;
        txtChekSalida.current.checked = false;
        txtChekTraslado.current.checked = false;
        txtChekAjuste.current.checked = false;
        txtChekDonacion.current.checked = false;
        txtChekPrestamo.current.checked = false;
        txtChekResguardo.current.checked = false;
        txtChekCompra.current.checked = false;
        txtChekVence.current.checked = false;
      }
    }

    if (e.target.name === 'todos') {
      if (e.target.checked) {
        setValidatipo(0);
        setTipoope('');
        setFilter(1);
        setTip({
          ingreso: '',
          salida: '',
          traslado: '',
          donacion: '',
          prestamo: '',
          ajuste: '',
          resguardo: '',
          compra: '',
          vencimiento: ''
        });
        txtChekIngreso.current.checked = false;
        txtChekSalida.current.checked = false;
        txtChekTraslado.current.checked = false;
        txtChekAjuste.current.checked = false;
        txtChekDonacion.current.checked = false;
        txtChekPrestamo.current.checked = false;
        txtChekResguardo.current.checked = false;
        txtChekCompra.current.checked = false;
        txtChekVence.current.checked = false;
      } else {
        setValidatipo(1);
        setTipoope('');
        setFilter(0);
        setTip({
          ingreso: '',
          salida: '',
          traslado: '',
          donacion: '',
          prestamo: '',
          ajuste: '',
          resguardo: '',
          compra: '',
          vencimiento: ''
        });
        txtChekIngreso.current.checked = false;
        txtChekSalida.current.checked = false;
        txtChekTraslado.current.checked = false;
        txtChekAjuste.current.checked = false;
        txtChekDonacion.current.checked = false;
        txtChekPrestamo.current.checked = false;
        txtChekResguardo.current.checked = false;
        txtChekCompra.current.checked = false;
        txtChekVence.current.checked = false;
      }
    }

    if (e.target.name === 'ingreso') {
      setTipoope(' and opdeta.tipomovimiento in ');
      setFilter(2);
    } else if (e.target.name === 'salida') {
      setTipoope(' and opdeta.tipomovimiento in ');
      setFilter(3);
    } else if (e.target.name === 'traslado') {
      setTipoope(' and opdeta.tipomovimiento in ');
      setFilter(4);
    } else if (e.target.name === 'donacion') {
      setTipoope(' and opdeta.tipomovimiento in ');
      setFilter(5);
    } else if (e.target.name === 'prestamo') {
      setTipoope(' and opdeta.tipomovimiento in ');
      setFilter(6);
    } else if (e.target.name === 'ajuste') {
      setTipoope(' and opdeta.tipomovimiento in ');
      setFilter(7);
    } else if (e.target.name === 'resguardo') {
      setTipoope(' and opdeta.tipomovimiento in ');
      setFilter(8);
    } else if (e.target.name === 'compra') {
      setTipoope(' and opdeta.tipomovimiento in ');
      setFilter(9);
    } else if (e.target.name === 'vencimiento') {
      setTipoope(' and opdeta.tipomovimiento in ');
      setFilter(10);
    }

    if (e.target.name !== 'todos' && e.target.name !== 'chektodos') {
      setTip({ ...tip, [e.target.name]: e.target.checked ? e.target.value : '' });
    }

    if (e.target.name === 'tproducto') {
      if (e.target.value === '0') {
        setIdtproduct('');
      } else {
        let valor = ' and p.idtipoproducto = ' + e.target.value;
        setIdtproduct(valor);
      }
    } else if (e.target.name === 'marca') {
      if (e.target.value === '0') {
        setIdmarca('');
      } else {
        let valor = ' and p.idfabricante = ' + e.target.value;
        setIdmarca(valor);
      }
    }

  }

  const imprimirOperacionInventario = () => {

    let almacen;
    var reporte = "";
    let tipooperacion = '';

    const tiparray = Object.entries(tip).map(([key, value]) => (value));

    if (tipoope !== '' && tiparray.length > 0) {
      let tipos = [];
      for (let i = 0; i < tiparray.length; i++) {
        if (tiparray[i].length > 0) {
          tipos.push("'" + tiparray[i] + "'");
        }
      }
      tipooperacion = tipoope + '(' + tipos + ')';
    }

    if (valida === 1 && validainput === false) {
      if (filter === 1) {
        almacen = idclient + ' and OI.idalmacen = ' + idalmacen + idtproduct + idmarca;
      } else {
        let condiproducto = ' and p.codigo = ' + "'" + txtCodigo.current.value + "'";
        almacen = idclient + condiproducto + ' and op.idalmacenorigen = ' + idalmacen + tipooperacion + idtproduct + idmarca;
      }
    } else if (valida === 1 && validainput === true) {
      almacen = idclient + ' and op.idalmacenorigen = ' + idalmacen + tipooperacion + idtproduct + idmarca;
    } else {
      let condiproducto = "";
      if (filter !== 1 && validainput === false) {
        condiproducto = ' and p.codigo = ' + "'" + txtCodigo.current.value + "'";
      } else {
        condiproducto = '';
      }
      almacen = idclient + condiproducto + tipooperacion + idtproduct + idmarca;
    }

    var reporte = "ReporteOperacionesInventario";
    let desdec = "'" + moment(desde).format('DD-MM-YYYY') + "'";
    let hastac = "'" + moment(hasta).format('DD-MM-YYYY') + "'";
    let id = idproduct;

    if (validainput === true) {
      window.open(
        `${op.reportes}/almacen?afiliado=${afiliado}&reporte=ReporteDetaOpeInventarioTodos&condi=${almacen}&desde=${desdec}&hasta=${hastac}&valida=${valida}`,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
      );
    } else {
      if (filter !== 1) {
        window.open(
          `${op.reportes}/almacen?afiliado=${afiliado}&reporte=ReporteDetaOpeInventarioPorProductos&condi=${almacen}&desde=${desdec}&hasta=${hastac}&valida=${valida}`,
          "Planilla",
          "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
        );
      } else {
        window.open(op.reportes + "/almacen?afiliado=" + afiliado + "&reporte=" + reporte + "&codigo=" + id + "&desde=" + desdec + "&hasta=" + hastac + "&almacen=" + almacen + "&valida=" + valida, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
      }
    }

  }

  const handleAceptaProducto = (values) => {
    setMostrar1(false);
    setVinput(false);
    txtNombre.current.value = values.nombrecorto;
    txtCodigo.current.value = values.codigo;
    setIdproduct(values.idproducto);
    setHabimarcatipopro(false);
  };

  const handleAceptaAlmacen = (values) => {
    setMostrar2(false);

    txtNombreAlmacen.current.value = values.descripcion;
    txtNumAlmacen.current.value = values.idalmacen;
    setIdalmacen(values.idalmacen);

  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });

  };

  const cerrarModal = () => {
    blanquear();
    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
  }

  const seleccionarProducto = (id) => {
    let campos = "idproducto, nombre";
    let nomtab = "producto";
    let nomid = "codigo";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.idproducto > 0) {
            setIdproduct(response.data.idproducto);
            txtNombre.current.value = response.data.nombre;
            setVinput(false);
            setHabimarcatipopro(false);
          } else {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Código y/o Producto no Existe !', icono: 'informacion' });
            setVinput(true);
            setHabimarcatipopro(true);
            txtCodigo.current.value = "";
            setIdproduct(null);
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const handleInputNumeroChange = (event) => {
    event.preventDefault();
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        if (event.target.name === "codigo") {
          seleccionarProducto(event.target.value.toUpperCase());
        } else if (event.target.name === "nalmacen") {
          seleccionarAlmacen(event.target.value);
        }
      }
    }
  };

  const seleccionarAlmacen = (id) => {
    let campos = "idalmacen, descripcion";
    let nomtab = "almacen";
    let nomid = "idalmacen";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.idalmacen > 0) {
            setIdalmacen(response.data.idalmacen);
            txtNombreAlmacen.current.value = response.data.descripcion;
          } else {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Código y/o Almacen no Existe !', icono: 'informacion' });
            txtNumAlmacen.current.value = "";
            setIdalmacen('');
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarTipoProductos = () => {

    let campos = 'idtipoproducto, trim(descripcion) as descripcion';
    let nomtab = 'tipoproducto';
    let orden = 'idtipoproducto';

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    setActivate(true);

    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {

      if (response.status === 200) {
        if (response.data.length > 0) {

          let datos = [];

          for (let i = 0; i < response.data.length; i++) {

            if (response.data[i].idtipoproducto !== '0') {
              datos.push({
                idtipoproducto: response.data[i].idtipoproducto,
                descripcion: response.data[i].descripcion
              });
            }

          }
          setTipoproducto(datos);
        }
      }


    }).catch(function (error) {

      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
      setActivate(false);

    }).finally(() => {
      setActivate(false);
    })

  }

  const seleccionarFabricante = () => {

    let campos = 'idfabricante, trim(descripcion) as descripcion';
    let nomtab = 'fabricante';
    let orden = 'idfabricante';

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    setActivate(true);

    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {

      if (response.status === 200) {
        if (response.data.length > 0) {

          let datos = [];

          for (let i = 0; i < response.data.length; i++) {

            if (response.data[i].idfabricante !== '0') {
              datos.push({
                idfabricante: response.data[i].idfabricante,
                descripcion: response.data[i].descripcion
              });
            }

          }
          setMarca(datos);
        }
      }


    }).catch(function (error) {

      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
      setActivate(false);

    }).finally(() => {
      setActivate(false);
    })

  }

  const onChekval = (e) => {

    if (e.target.id === 'cliente') {
      if (txtTodosCliente.current.checked === true) {
        setCombocliente(0);
        setIdclient('');
        txtNomrespon.current.value = '';
        txtRifrespon.current.value = '';
        txtCbmrif.current.value = '';
      } else {
        setCombocliente(1);
        setClientvende('cliente');
      }
    }

  }

  const handleCliente = (e) => {
    e.preventDefault();
    if (e.which === 13 || typeof (e.which) === 'undefined') {
      if (e.target.value !== '') {
        setClientvende('cliente');
        if (clientvende === 'cliente') {
          selectResponsable(tiporif + e.target.value);
        }
      }
    }
  };

  const selectResponsable = (id) => {

    let campos = '*';
    let nomtab = 'agente';
    let nomid = 'rif';
    let nomid2 = clientvende;
    let endpoint = `${op.conexion}/api/consulta/modeli2?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}&nomid2=${nomid2}&id2=true`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.idagente > 0) {
            if (clientvende === 'cliente') {
              txtNomrespon.current.value = response.data.nombre;
              setIdclient(' and ag.idagente = ' + response.data.idagente);
              btnAcepta.current.focus();
            } else {
            }
          } else {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ RIF y/o Cliente no Registrado !', icono: 'informacion' });
            txtRifrespon.current.value = '';
            txtNomrespon.current.value = '';
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const catalogoClienteVendedor = (ope) => (e) => {
    e.preventDefault();
    if (ope === 1) {
      setClientvende('cliente');
      setMostrar3(true);
    } else {
      setClientvende('vendedor');
      setMostrar3(true);
    }
  };

  const handleAceptaCliente = (values) => {
    setMostrar3(false);
    if (clientvende === 'cliente') {
      txtCbmrif.current.value = values.rif.substring(0, 1);
      txtRifrespon.current.value = values.rif.substring(1, 11);
      txtNomrespon.current.value = values.nombre;
      selectResponsable(values.rif);
    }

  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {

        if (props.ope === 1) {
          seleccionarTipoProductos();
          seleccionarFabricante();
          txtDesde.current.value = moment(fechasistema).format('YYYY-MM-DD');
          txtHasta.current.value = moment(fechasistema).format('YYYY-MM-DD');
          setDesde(moment(fechasistema).format('YYYY-MM-DD'));
          setHasta(moment(fechasistema).format('YYYY-MM-DD'));
          setFilter(1);
          txtChekTodos.current.checked = true;
          txtCodigo.current.focus();
        }


      }}
    >
      <Modal.Header className='azulGradiant2 header-modal'>
        <div className='fw-bold' style={{ color: "#fff" }}><h3>Imprimir Operaciones de Inventario</h3></div>

        <a href='#' ref={btnSalir} disabled={botones.salir} onClick={cancelar} className='text-light' ><i className="fas fa-times fa-1x shadow" > {/* Salir */}</i></a>

      </Modal.Header>
      <Modal.Body style={{ backgroundColor: "#FFF" }}>
        <Mensaje mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === 'Exito.' ?
              cerrarModal() :
              setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
          }
          } />
        <MensajeSiNo mensaje={mensajesino}
          onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
        <Dimmer active={activate} inverted>
          <Loader inverted>cargando...</Loader>
        </Dimmer>
        <div className='col-md-12 row mx-auto px-0'>

          <div className="row col-md-12 rounded mx-auto m-0 border-azul px-1">


            <div className='col-12 row m-0 px-0 py-2'>

              <div className='col-md-12 m-0 px-0 row'>

                <div className='col-pd-310 px-1 mb-3'>
                  <div className="input-group input-group-sm mb-2">
                    <label className="input-group-text" id="inputGroup-sizing-sm">TIPO PRODUCTO:</label>
                    <select ref={txtTipoproducto} name="tproducto" onChange={onChange} className="form-select form-select-sm text-center" aria-label=".form-select-sm example" >
                      <option value="0">TODOS</option>
                      {tipoproducto && tipoproducto.map((item, index) => (
                        <option key={index} value={item.idtipoproducto}> {item.descripcion} </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className='col-pd-280 mb-3'>
                  <div className="input-group input-group-sm mb-2">
                    <label className="input-group-text" id="inputGroup-sizing-sm">FABRICANTE:</label>
                    <select ref={txtMarca} name="marca" onChange={onChange} className="form-select form-select-sm text-center" aria-label=".form-select-sm example" >
                      <option value="0">TODOS</option>
                      {marca && marca.map((item, index) => (
                        <option key={index} value={item.idfabricante}> {item.descripcion} </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className='col-pd-100 mb-3 ml-auto'>
                  <div className="form-check">
                    <input className="form-check-input" ref={txtChkTodos} onChange={onChange} name="chektodos" type="checkbox" id="flexCheckDefault" />
                    <label className="form-check-label fw-bold text-black" for="flexCheckDefault" style={{ fontSize: '0.9rem' }}>
                      TODOS
                    </label>
                  </div>
                </div>

              </div>

              <div className='col-pd-280 px-1 mb-3'>
                <div className="input-group input-group-sm">
                  <label className="input-group-text fw-bold text-black" id="inputGroup-sizing-sm">CODIGO PRODUCTO:</label>
                  <input type="text" disabled={validainput} onKeyUp={handleInputNumeroChange} onBlur={handleInputNumeroChange} ref={txtCodigo} name='codigo' className="form-control fs-6 text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                  <button type="button" onClick={() => setMostrar1(true)} disabled={validainput} className="btn btn-success"><i className="fas fa-search"></i></button>
                </div>
              </div>

              <div className='col-pd-220 px-1 mb-3'>
                <div className="input-group input-group-sm">
                  <label className="input-group-text fw-bold text-black" id="inputGroup-sizing-sm">DESDE:</label>
                  <input type="date" disabled={props.ope === 0 ? true : false} onChange={onChange} ref={txtDesde} name='desde' className="form-control text-center fs-6 text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                </div>
              </div>

              <div className='col-pd-220 px-1 mb-3 ml-auto'>
                <div className="input-group input-group-sm">
                  <label className="input-group-text fw-bold text-black" id="inputGroup-sizing-sm">HASTA:</label>
                  <input type="date" disabled={props.ope === 0 ? true : false} onChange={onChange} ref={txtHasta} name='hasta' className="form-control text-center fs-6 text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                </div>
              </div>

              <div className='col-12 px-1 mb-3'>
                <div className="input-group input-group-sm">
                  <label className="input-group-text fw-bold text-black" id="inputGroup-sizing-sm">NOMBRE PRODUCTO:</label>
                  <textarea type="text" disabled={true} ref={txtNombre} name='nombre' /* style={{ height: idproduct !== null ? '47px' : '30px' }} */ className="form-control text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                </div>
              </div>

              <fieldset className='row col-sm-12 mx-auto border-azul rounded mb-3'>
                <legend className="float-none m-0 w-auto fw-bold text-black" style={{ fontSize: '0.8rem' }}>TIPO DE OPERACION:</legend>

                <div className='col-md-12 px-0 mb-2 row m-0 d-flex justify-content-around'>
                  <div className="form-check form-check-inline col-pd-100">
                    <input className="form-check-input" type="checkbox" ref={txtChekTodos} name='todos' onChange={onChange} id="flexCheckDefault77" />
                    <label className="form-check-label" for="flexCheckDefault77" style={{ fontSize: '0.8rem' }}>
                      TODOS
                    </label>
                  </div>
                  <div className="form-check form-check-inline col-pd-100">
                    <input className="form-check-input" type="checkbox" value={'INVENTARIO INICIAL'} disabled={validatipo === 1 ? false : true} ref={txtChekIngreso} name='ingreso' onChange={onChange} id="flexCheckDefault1" />
                    <label className="form-check-label" for="flexCheckDefault1" style={{ fontSize: '0.8rem' }}>
                      INGRESO
                    </label>
                  </div>
                  <div className="form-check form-check-inline col-pd-100">
                    <input className="form-check-input" type="checkbox" value={'COMPRA'} disabled={validatipo === 1 ? false : true} ref={txtChekCompra} name='compra' onChange={onChange} id="flexCheckDefault7" />
                    <label className="form-check-label" for="flexCheckDefault7" style={{ fontSize: '0.8rem' }}>
                      COMPRA
                    </label>
                  </div>
                  <div className="form-check form-check-inline col-pd-110">
                    <input className="form-check-input" type="checkbox" value={'VENTA'} disabled={validatipo === 1 ? false : true} ref={txtChekSalida} name='salida' onChange={onChange} id="flexCheckDefault2" />
                    <label className="form-check-label" for="flexCheckDefault2" style={{ fontSize: '0.8rem' }}>
                      SALIDA
                    </label>
                  </div>
                  <div className="form-check form-check-inline col-pd-110 px-1">
                    <input className="form-check-input" type="checkbox" value={'TRASLADO'} disabled={validatipo === 1 ? false : true} ref={txtChekTraslado} name='traslado' onChange={onChange} id="flexCheckDefault3" />
                    <label className="form-check-label" for="flexCheckDefault3" style={{ fontSize: '0.8rem' }}>
                      TRASLADO
                    </label>
                  </div>
                </div>

                <div className='col-md-12 px-0 mb-2 row m-0 d-flex justify-content-around'>
                  <div className="form-check form-check-inline col-pd-100">
                    <input className="form-check-input" type="checkbox" value={`OBSEQUIO/DONACIÓN','DONACIÓN`} disabled={validatipo === 1 ? false : true} ref={txtChekDonacion} name='donacion' onChange={onChange} id="flexCheckDefault4" />
                    <label className="form-check-label" for="flexCheckDefault4" style={{ fontSize: '0.8rem' }}>
                      OBSEQUIO
                    </label>
                  </div>
                  <div className="form-check form-check-inline col-pd-100">
                    <input className="form-check-input" type="checkbox" value={'PRESTAMO'} disabled={validatipo === 1 ? false : true} ref={txtChekPrestamo} name='prestamo' onChange={onChange} id="flexCheckDefault5" />
                    <label className="form-check-label" for="flexCheckDefault5" style={{ fontSize: '0.8rem' }}>
                      PRESTAMO
                    </label>
                  </div>
                  <div className="form-check form-check-inline col-pd-100">
                    <input className="form-check-input" type="checkbox" value={'AJUSTE'} disabled={validatipo === 1 ? false : true} ref={txtChekAjuste} name='ajuste' onChange={onChange} id="flexCheckDefault6" />
                    <label className="form-check-label" for="flexCheckDefault6" style={{ fontSize: '0.8rem' }}>
                      AJUSTE
                    </label>
                  </div>
                  <div className="form-check form-check-inline col-pd-110">
                    <input className="form-check-input" type="checkbox" value={'RESGUARDO'} disabled={validatipo === 1 ? false : true} ref={txtChekResguardo} name='resguardo' onChange={onChange} id="flexCheckDefault6" />
                    <label className="form-check-label" for="flexCheckDefault6" style={{ fontSize: '0.8rem' }}>
                      RESGUARDO
                    </label>
                  </div>
                  <div className="form-check form-check-inline col-pd-110 px-1">
                    <input className="form-check-input" type="checkbox" value={'VENCIMIENTO'} disabled={validatipo === 1 ? false : true} ref={txtChekVence} name='vencimiento' onChange={onChange} id="flexCheckDefault8" />
                    <label className="form-check-label" for="flexCheckDefault8" style={{ fontSize: '0.8rem' }}>
                      VENCIMIENTO
                    </label>
                  </div>
                </div>

              </fieldset>

              {/* <fieldset className='row col-sm-12 mx-auto border-azul rounded mb-1'>
                <legend className="float-none m-0 w-auto fs-4 fw-bold">Cliente:</legend>

                <div className='col-2 mx-auto'>
                  <div className="form-check">
                    <input className="form-check-input" name="cliente" value="1" ref={txtTodosCliente} onChange={onChekval} id="cliente" type="radio" />
                    <label className="form-check-label" for="exampleRa1">
                      Todos
                    </label>
                  </div>
                </div>

                <div className='col-2 mx-auto'>
                  <div className="form-check">
                    <input className="form-check-input" name="cliente" value="2" ref={txtPorCliente} onChange={onChekval} id="cliente" type="radio" />
                    <label className="form-check-label" for="exampleRa2">
                      Por Cliente
                    </label>
                  </div>
                </div>

                <div className='col-7 mr-auto px-0'>
                  <div className="input-group input-group-sm col-7 px-1 ml-auto">
                    <label className="input-group-text" id="inputGroup-sizing-sm">RIF:</label>
                    <select className="form-select col-3" ref={txtCbmrif} name='nci' onChange={onChange} aria-label="Default select example">
                      <option value="V">V</option>
                      <option value="E">E</option>
                      <option value="J">J</option>
                      <option value="P">P</option>
                      <option value="G">G</option>
                    </select>
                    <input type="text" ref={txtRifrespon} disabled={combocliente === 1 ? false : true} onKeyUp={handleCliente} onBlur={handleCliente} className="form-control text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                    <button disabled={combocliente === 1 ? false : true} type="button" onClick={catalogoClienteVendedor(1)} className="btn btn-success"><i className="fas fa-search"></i></button>
                  </div>
                </div>

                <div className='col-12 row m-0 py-3'>

                  <div className='col-12'>
                    <div className="input-group input-group-sm">
                      <label className="input-group-text" id="inputGroup-sizing-sm">Nombre del Cliente:</label>
                      <input type="text" ref={txtNomrespon} disabled={true} className="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                    </div>
                  </div>

                </div>

              </fieldset> */}

              <div className='col-12 row m-0 border-azul rounded py-2'>

                <div className='col-pd-400 px-0 mb-3 row m-0'>
                  <label className="form-check-label col-pd-104 text-left px-1 d-flex align-items-center fw-bold text-black" for="flexSwitchCheckDefault" style={{ fontSize: '0.8rem' }}>ALMACEN:</label>
                  <div className="form-check form-check-inline col-pd-145">
                    <input className="form-check-input" type="radio" name="inlineRadioOptions" defaultChecked onChange={onChange} id="inlineRadio1" value="1" />
                    <label className="form-check-label" for="inlineRadio1" style={{ fontSize: '0.8rem' }}>TODOS</label>
                  </div>
                  <div className="form-check form-check-inline col-pd-130">
                    <input className="form-check-input" type="radio" name="inlineRadioOptions" onChange={onChange} id="inlineRadio2" value="2" />
                    <label className="form-check-label" for="inlineRadio2" style={{ fontSize: '0.8rem' }}>POR ALMACEN</label>
                  </div>
                </div>

                {valida === 1 ? <div className='col-pd-220 px-0 mb-3'>
                  <div className="input-group input-group-sm">
                    <label className="input-group-text" id="inputGroup-sizing-sm">CODIGO ALMACEN: </label>
                    <input autoComplete='off' type="text" disabled={props.ope === 0 ? true : false} name="nalmacen" onKeyUp={handleInputNumeroChange} onBlur={handleInputNumeroChange} ref={txtNumAlmacen} className="form-control bg-transparent fs-6" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                    <button type="button" onClick={() => setMostrar2(true)} disabled={props.ope === 0 ? true : false} className="btn btn-success"><i className="fas fa-search"></i></button>
                  </div>
                </div> : ''}

                {valida === 1 ? <div className='col-12 px-0 mb-3'>
                  <div className="input-group input-group-sm">
                    <label className="input-group-text" id="inputGroup-sizing-sm">NOMBRE ALMACEN:</label>
                    <input type="text" disabled={true} ref={txtNombreAlmacen} name='nombre' className="form-control fs-6 text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                  </div>
                </div> : ''}

              </div>

            </div>



          </div>

        </div>
      </Modal.Body >
      <Modal.Footer>
        <div className="row m-0 col-md-12 mx-auto">
          <div className='col-md-11 ml-auto px-0 m-0 d-flex justify-content-end'>
            <button ref={btnAcepta} disabled={vinput} onClick={onChangeValidar} className="btn btn-sm rounded-pill btn-primary mx-1"><i className="fas fa-print">  Imprimir</i></button>
            <button ref={btnCancela} onClick={cancelar} className="btn btn-danger btn-sm rounded-pill mx-1"><i className="fas fa-window-close"> Cancelar</i></button>
          </div>
        </div>

      </Modal.Footer>
      <CatalogoAlmacen
        show={mostrar2}
        onHideCancelar={() => setMostrar2(false)}
        onHideAceptaCatalogo={handleAceptaAlmacen}
      />
      <CatalogoProductosExistencias
        show={mostrar1}
        onHideCancelar={() => setMostrar1(false)}
        onHideAceptaCatalogo={handleAceptaProducto}
      />
      <CatalogoCliente
        show={mostrar3}
        nomid={clientvende}
        onHideCancelar={() => setMostrar3(false)}
        onHideAceptaCatalogo={handleAceptaCliente}
      />
    </Modal >
  );
}




// WEBPACK FOOTER //
// ./src/components/almacen/ImprimirOpInventarios.js